"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedCrypto = void 0;
const CRYPTO_OPTIONS = {
    AVAX: {
        image: "/coins/avax.png",
        label: "Avalanche",
        network: "avax",
        decimals: 18,
    },
    BAT: {
        image: "/coins/bat.png",
        label: "Basic Attention Token",
        network: "eth",
        decimals: 18,
        buyOnly: true,
    },
    BCH: {
        image: "/coins/bch.png",
        label: "Bitcoin Cash",
        network: "bch",
        decimals: 8,
    },
    BNB: {
        image: "/coins/bnb.png",
        label: "Binance Coin",
        network: "bnb",
        decimals: 8,
        buyOnly: true,
    },
    BTC: {
        image: "/coins/btc.png",
        label: "Bitcoin",
        network: "btc",
        decimals: 8,
    },
    COMP: {
        image: "/coins/comp.png",
        label: "Compound",
        network: "eth",
        decimals: 8,
        buyOnly: true,
    },
    DASH: {
        image: "/coins/dash.png",
        label: "Dash",
        network: "dash",
        decimals: 18,
        buyOnly: true,
    },
    DOGE: {
        image: "/coins/doge.png",
        label: "Dogecoin",
        network: "doge",
        decimals: 8,
        buyOnly: true,
    },
    DOT: {
        image: "/coins/dot.png",
        label: "Polkadot",
        network: "dot",
        decimals: 10,
        buyOnly: true,
    },
    ETH: {
        image: "/coins/eth.png",
        label: "Ethereum",
        network: "eth",
        decimals: 18,
    },
    GUSD: {
        image: "/coins/gusd.png",
        label: "Gemini Dollar",
        network: "eth",
        decimals: 2,
        buyOnly: true,
    },
    LTC: {
        image: "/coins/ltc.png",
        label: "Litecoin",
        network: "ltc",
        decimals: 8,
    },
    MATIC: {
        image: "/coins/matic.png",
        label: "Polygon",
        network: "matic",
        decimals: 18,
        buyOnly: true,
    },
    SHIB: {
        image: "/coins/shib.png",
        label: "Shiba Inu",
        network: "eth",
        decimals: 18,
        buyOnly: true,
    },
    SUSHI: {
        image: "/coins/sushi.png",
        label: "SushiSwap",
        network: "eth",
        decimals: 18,
        buyOnly: true,
    },
    UNI: {
        image: "/coins/uni.png",
        label: "Uniswap",
        network: "eth",
        decimals: 18,
        buyOnly: true,
    },
    USDC: {
        image: "/coins/usdc.png",
        label: "USD Coin",
        network: "eth",
        decimals: 18,
    },
    USDT: {
        image: "/coins/usdt.png",
        label: "Tether",
        network: "eth",
        decimals: 6,
    },
    WBTC: {
        image: "/coins/wbtc.png",
        label: "Wrapped Bitcoin",
        network: "eth",
        decimals: 8,
        buyOnly: true,
    },
    XLM: {
        image: "/coins/xlm.png",
        label: "Stellar",
        network: "xlm",
        decimals: 18,
    },
    XRP: {
        image: "/coins/xrp.png",
        label: "XRP",
        network: "xrp",
        decimals: 18,
        buyOnly: true,
    },
    VERSE: {
        image: "/coins/verse.png",
        label: "Verse",
        network: "eth",
        decimals: 18,
        buyOnly: true,
    },
};
const getSelectedCrypto = (isBuy, initialCrypto) => {
    // if no initail crypto don't set
    if (!initialCrypto || !CRYPTO_OPTIONS[initialCrypto.toUpperCase()])
        return {};
    const cryptoOption = CRYPTO_OPTIONS[initialCrypto.toUpperCase()];
    // if buy and initial crypto is available
    if (isBuy) {
        return {
            selectedCrypto: Object.assign({ code: initialCrypto.toUpperCase() }, cryptoOption),
        };
    }
    // if sell and initial crypto is available to sell
    if (!isBuy && !cryptoOption.buyOnly) {
        return {
            selectedCrypto: Object.assign({ code: initialCrypto.toUpperCase() }, cryptoOption),
        };
    }
    return {};
};
exports.getSelectedCrypto = getSelectedCrypto;
exports.default = CRYPTO_OPTIONS;
//# sourceMappingURL=cryptoOptions.js.map